import { useContext } from 'react';
import { ChartsDataContext } from '../contexts/ChartsDataContext';

export const useChartsDataContext = () => {
    return useContext(ChartsDataContext);
};
